import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import HeaderBack from 'components/components/account/components/HeaderBack';
import {
  setReservationToEdit,
  fetchPriceList,
  setCardIdInReservationEdit,
  createSuccessNotification,
  createErrorNotification
} from 'components/actions/serviceActions';
import withRouter from 'components/components/common/withRouter';
import SecureLoadingContent from 'components/components/common/SecureLoadingContent';
import Cards from 'components/components/common/cards/Cards';
import LoadingSpinner from 'components/components/common/LoadingSpinner';
import ReservationUpdateHelper from './utils/ReservationUpdateHelper';
import SummaryContent from './componentsSupplementSummary/SummaryContent';
import axios from 'components/AppRequest';
import mergeErrors from 'components/helpers/mergeErrors';
import TransHelper from 'components/common/translations/TransHelper';
import { STRIPE_PK } from 'components/windowEnvs';

class SupplementSummary extends Component {

  constructor(props) {
    super(props);
    this.cardElementObject = null;
  }

  state = {
    paymentError: null,
    saveCard: true,
    cardErrors: null,
    loading: false,
    paymentIntentId: null,
    csk: null,
    paymentDescription: null
  }

  trans = (key, pref = "content.supplementSummary") => {
    return TransHelper.translate(this.props.locale, pref + "." + key);
  }

  transNotify = (type) => {
    return this.trans(type, 'content.notifications.suplementSummary');
  }

  t = (key) => {
    return TransHelper.translate(this.props.locale, key);
  }

  componentDidMount() {
    this.stripe = Stripe(STRIPE_PK);
    if (!this.props.reservationUpdate.id) {
      TransHelper.redirect(this.props, 'routes.url.dashboard');
    }
  }

  onChangeSaveCard = () => {
    this.setState({ saveCard: !this.state.saveCard })
  }

  resetCardElement = () => {
    this.cardElementObject = null;
  }

  handleClickToBack = (e) => {
    e.preventDefault();
    TransHelper.redirect(
      this.props,
      'routes.url.dashboardEdit',
      { 'id': this.props.reservationUpdate.id }
    );
  }

  differenceInPrice = () => {
    const { reservation, reservationUpdate } = this.props;
    if (reservationUpdate.price) {
      var price = parseInt(reservationUpdate.price) - parseInt(reservation.price);
      if (price > 0) {
        return '+' + price;
      } else {
        return price;
      }
    } else {
      return '--';
    }
  }

  createOnlinePaymentReservation = () => {
    this.setState({ loading: true });
    const { reservation, reservationUpdate } = this.props;
    var helper = new ReservationUpdateHelper(reservation, reservationUpdate);
    var params = helper.requestParams();

    axios.post('/pwa/reservation/is-valid-reservation-update', params)
      .then(response => {
        this.stripeConfirmPaymentRequest();
      })
      .catch(err => {
        console.error(err);
        this.props.createErrorNotification({
          title: this.transNotify('error'),
          message: mergeErrors(err.response.data.errors)
        });
        this.setState({ loading: false });
      });
  }

  stripeConfirmPaymentRequest = () => {
    const { reservationUpdate } = this.props;

    if (reservationUpdate.selectedCardId) {
      var stripePromise = this.stripe.handleCardPayment(
        this.state.csk, {
          payment_method: reservationUpdate.selectedCardId,
        }
      );
    } else {
      var stripePromise = this.stripe.handleCardPayment(
        this.state.csk, this.cardElementObject, {
          payment_method_data: {
            billing_details: { name: this.props.loggedCustomer.name },
          }
        }
      );
    }

    stripePromise.then((paymentResult) => {
      if (paymentResult.error) {
        console.log("error", paymentResult.error)
        this.setState({ cardErrors: paymentResult.error.message });
        this.props.createErrorNotification({
          title: this.transNotify('error'),
          message: mergeErrors(paymentResult.error.message)
        });
        this.setState({ loading: false });
      } else {
        this.reservationOnlineSaveAfterSuccessPayment(paymentResult);
      }
    });
  }

  reservationOnlineSaveAfterSuccessPayment = (paymentResult) => {
    const { reservation, reservationUpdate } = this.props;
    var helper = new ReservationUpdateHelper(reservation, reservationUpdate);
    helper.setPaymentId(paymentResult.paymentIntent.id);
    helper.setPaymentMethodId(paymentResult.paymentIntent.payment_method);
    var paramsPayment = helper.requestParamsWithPayment(this.state);

    this.setState({ loading: true }, () => {
      axios.post('/pwa/reservation/update', paramsPayment)
        .then(response => {
          this.props.createSuccessNotification({
            message: this.transNotify('success')
          });
          this.setState({ loading: false });
          TransHelper.redirect(this.props, 'routes.url.dashboard');
        })
        .catch(err => {
          var mergedErrors = mergeErrors(err.response.data.errors);
          this.props.createErrorNotification({
            title: this.transNotify('error'),
            message: mergedErrors
          })
          this.setState({ loading: false });
          console.log('err', err)
        });
    });
  }

  bookAction = (e) => {
    e.preventDefault();
    this.createOnlinePaymentReservation();
  }

  createPaymentIntent = (selectedCardId = null) => {
    const { reservation, reservationUpdate } = this.props;
    this.setState({ loading: true, cardErrors: null });
    var helper = new ReservationUpdateHelper(reservation, reservationUpdate);
    helper.setPaymentIntentId(this.state.paymentIntentId);
    var params = helper.requestParamsWithPayment(this.state);
    params.data["selectedCardId"] = selectedCardId;
    this.mountStripe(selectedCardId);
    axios.post('/pwa/reservation/create-payment-intent-update', params)
      .then(response => {
        this.setState({
          csk: response.data.csk,
          paymentIntentId: response.data.id,
          loading: false,
          paymentDescription: response.data.description,
        });
      })
      .catch(err => {
        this.setState({ loading: false });
        console.error(err)
        this.props.createErrorNotification({
          title: this.transNotify('error'),
          message: mergeErrors(err.response.data.errors)
        });
      });
  }

  mountStripe = (selectedCardId) => {
    var stripeContainer = document.getElementById("stripe-container");
    if (selectedCardId === null) {
      stripeContainer.style.display = "block";
      var stripeStyles = {
        base: {
          color: '#32325d',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      };
      if (this.cardElementObject === null) {
        var elements = this.stripe.elements();
        var cardElement = elements.create(
          'card',
          {
            hidePostalCode: true,
            style: stripeStyles
          },
        );
        cardElement.mount('#card-element');
        this.cardElementObject = cardElement;
      } else {
        this.cardElementObject.mount('#card-element');
      }
    } else {
      stripeContainer.style.display = "none";
      if (this.cardElementObject) {
        this.cardElementObject.unmount();
      }
    }
  }

  handleSelectCard = (cardId) => {
    this.props.setCardIdInReservationEdit(cardId);
    if (cardId !== null) {
      this.createPaymentIntent(cardId);
    }
  }

  render() {
    if (!this.props.reservationUpdate.id) {
      return null;
    }
    const { reservationUpdate, reservation } = this.props;
    var helper = new ReservationUpdateHelper(reservation, reservationUpdate);

    return (
      <SecureLoadingContent softLoading>
        <div className="content" style={{ margin: 0 }}>
          {/******** headers  ********/}
          <HeaderBack
            className="header-back--dashboard"
            link={"/dashboard/edit/" + reservationUpdate.id}
            name="content.layout.sidebarAndHeader.editReservation"
            title="content.layout.sidebarAndHeader.backToEditTitle"
            onClick={this.handleClickToBack}
            locale={this.props.locale}
          />
          {/******** end headers  ********/}
          <div className={classNames(
            'grid-layout',
            'grid-layout--vh',
            'grid-layout__item--content-center',
            'grid-layout--mobile'
          )}>
            {/******** summary  ********/}
            <SummaryContent
              reservation={reservation}
              reservationUpdate={reservationUpdate}
              locale={this.props.locale}
            />
            {/******** end summary  ********/}

            {/******** cards  ********/}
            {helper.haveToPayExtra() && (
              <div className={classNames(
                'grid-layout__item',
                'grid-layout__item--desc',
                'grid-layout__item--content-center'
              )}>
                <div className="content__desc" style={{ paddingBottom: '25px' }}>
                  <Cards
                    cardErrors={this.state.cardErrors}
                    disableInvoice
                    onChangeSaveCard={this.onChangeSaveCard}
                    saveCard={this.state.saveCard}
                    setCardId={this.handleSelectCard}
                    selectedCardId={reservationUpdate.selectedCardId}
                    locale={this.props.locale}
                    resetCardElement={this.resetCardElement}
                    createPaymentIntent={this.createPaymentIntent}
                  />
                  {this.state.loading
                    ?
                    <LoadingSpinner className="button button--expand" />
                    :
                    <button
                      className="button button--expand"
                      onClick={this.bookAction}
                    >
                      {this.trans('paySupl')}
                    </button>
                  }
                  {this.state.paymentError && (
                    <p className="msg msg--error msg--static">{this.state.paymentError}</p>
                  )}
                </div>
              </div>
            )}
            {/******** end cards  ********/}
          </div>
        </div>
      </SecureLoadingContent>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    reservation: state.service.editedReservation,
    reservationUpdate: state.service.paramsForReservationUpdate,
    locale: state.app.locale,
    loggedCustomer: state.app.customer,
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    {
      setReservationToEdit, fetchPriceList,
      setCardIdInReservationEdit, createSuccessNotification, createErrorNotification
    }
  )(SupplementSummary)
);
